const checklistActionTypes = {
  CREATE_CHECKLIST_FOLDER: 'CREATE_CHECKLIST_FOLDER',
  CREATE_NEW_CHECKLIST_IN_FOLDER: 'CREATE_NEW_CHECKLIST_IN_FOLDER',
  ADD_ITEM_IN_EXIST_CHECKLIST: 'ADD_ITEM_IN_EXIST_CHECKLIST',
  UPDATE_CHECKLIST_NAME: 'UPDATE_CHECKLIST_NAME',
  REMOVE_CHECKLIST_FOLDER: 'REMOVE_CHECKLIST_FOLDER',
  REMOVE_CHECKLIST: 'REMOVE_CHECKLIST',
  REMOVE_CHECKLIST_ITEM: 'REMOVE_CHECKLIST_ITEM',
  UPDATE_CHECKLIST_ITEM: 'UPDATE_CHECKLIST_ITEM',
  UPDATE_CHECKLIST_FOLDER: 'UPDATE_CHECKLIST_FOLDER',
  LIST_CHECKLIST_FOLDER: 'LIST_CHECKLIST_FOLDER',
  SET_CHECKLIST_FOLDER_LIST: 'SET_CHECKLIST_FOLDER_LIST',
  SET_CHECKLIST_FOLDER_IS_FETCHING: 'SET_CHECKLIST_FOLDER_IS_FETCHING',
  SET_CHECKLIST_FOLDER_IS_ADDING: 'SET_CHECKLIST_FOLDER_IS_ADDING',
  SET_CHECKLIST_IS_ADDING: 'SET_CHECKLIST_IS_ADDING',
  SET_CHECKLIST_IS_UPDATING: 'SET_CHECKLIST_IS_UPDATING',
  SET_CHECKLIST_IS_REMOVING: 'SET_CHECKLIST_IS_REMOVING',
  SET_CHECKLIST_ITEM_IS_REMOVING: 'SET_CHECKLIST_ITEM_IS_REMOVING',
  SET_CHECKLIST_ITEM_IS_UPDATING: 'SET_CHECKLIST_ITEM_IS_UPDATING',
  SET_EXIST_CHECKLIST_ITEM_IS_ADDING: 'SET_EXIST_CHECKLIST_ITEM_IS_ADDING',
  SET_CHECKLIST_FOLDER_IS_REMOVING: 'SET_CHECKLIST_FOLDER_IS_REMOVING',
  SET_CHECKLIST_FOLDER_IS_UPDATEING: 'SET_CHECKLIST_FOLDER_IS_UPDATEING',
  FOLDERS_CHECKLIST_DATA: 'FOLDERS_CHECKLIST_DATA',
  CHECKLIST_ITEMS_LIST_DATA: 'CHECKLIST_ITEMS_LIST_DATA',
  IS_CHECKLIST_ADDING_SUCCESS: 'IS_CHECKLIST_ADDING_SUCCESS',
  IS_CHECKLIST_ITEM_ADDING_SUCCESS: 'IS_CHECKLIST_ITEM_ADDING_SUCCESS',
  IS_CHECKLIST_ITEM_UPDATING_SUCCESS: 'IS_CHECKLIST_ITEM_UPDATING_SUCCESS',
  IS_CHECKLIST_REMOVING_SUCCESS: 'IS_CHECKLIST_REMOVING_SUCCESS',
  IS_CHECKLIST_UPDATING_SUCCESS: 'IS_CHECKLIST_UPDATING_SUCCESS',
  IS_EXIST_CHECKLIST_ADDING_SUCCESS: 'IS_EXIST_CHECKLIST_ADDING_SUCCESS',
  IS_CHECKLIST_ITEM_REMOVING_SUCCESS: 'IS_CHECKLIST_ITEM_REMOVING_SUCCESS',
  UPDATE_CHECKLIST_FOLDER_SORT_ORDER: 'UPDATE_CHECKLIST_FOLDER_SORT_ORDER',
  UPDATE_CHECKLIST_ITEM_SORT_ORDER: 'UPDATE_CHECKLIST_ITEM_SORT_ORDER',
};
export default checklistActionTypes;
